import styled from "styled-components";
import { setFont } from "@similarweb/styles";
import { AppRow } from "pro-features/components/core cells/src/CoreAppCell/StyledComponents";

export const AppCellContainer = styled.div`
    ${AppRow} {
        ${setFont({ $weight: 400 })};
    }
    .ItemIcon--app {
        width: 24px;
        height: 24px;
    }
`;
